import { axiosApiInstance } from "../axios";
import type { FinanceDateRangeValue } from "./dates";
import type {
  FinancePriceHistoryResponse,
  FinanceReceivingFilters,
  FinanceReceivingResponse,
} from "./receiving-types";

function filterParams(filters: FinanceReceivingFilters) {
  return {
    supplier_ids: filters.supplierIds.length ? filters.supplierIds : undefined,
    class_ids: filters.classIds.length ? filters.classIds : undefined,
    category_ids: filters.categoryIds.length ? filters.categoryIds : undefined,
    product_ids: filters.productIds.length ? filters.productIds : undefined,
    warehouse_ids: filters.warehouseIds.length
      ? filters.warehouseIds
      : undefined,
    location_ids: filters.locationIds.length ? filters.locationIds : undefined,
    cost_statuses: filters.costStatuses.length
      ? filters.costStatuses
      : undefined,
  };
}

export async function fetchFinanceReceiving(
  range: FinanceDateRangeValue,
  page = 1,
  search = "",
  filters: FinanceReceivingFilters,
): Promise<FinanceReceivingResponse> {
  const response = await axiosApiInstance.get<FinanceReceivingResponse>(
    "finance/receiving",
    {
      params: {
        from: range.from,
        to: range.to,
        page,
        search: search || undefined,
        group_by: filters.groupBy,
        ...filterParams(filters),
      },
    },
  );
  return response.data;
}

export async function fetchFinancePriceHistory(
  range: FinanceDateRangeValue,
  page = 1,
  search = "",
  filters: FinanceReceivingFilters,
): Promise<FinancePriceHistoryResponse> {
  const response = await axiosApiInstance.get<FinancePriceHistoryResponse>(
    "finance/receiving/price-history",
    {
      params: {
        from: range.from,
        to: range.to,
        page,
        search: search || undefined,
        ...filterParams(filters),
      },
    },
  );
  return response.data;
}
